import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { AlertDataState } from '@/zustand/interfaces/alert-data';

export const useAlertData = create<
  AlertDataState,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      alert: null,
      setAlertData: (alert) => {
        set({
          alert
        });
        if (!alert || alert.isDismissible === false) return;

        const timer = setTimeout(() => set({ alert: null }), 4000);
        return () => clearTimeout(timer);
      }
    }),
    {
      name: 'alertData',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
